import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class HomeService extends BaseService {

    async enviarExtractoCabal( filtros: Record<string, any> ) {
        this.url = `${environment.host}/home/extracto-cabal`
        try {
            await this.updateToken();
            const resp = await lastValueFrom(this.http.post<any>(this.url, { ...filtros }, { headers: this.header }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async actualizarExtractoCabal( filtros: Record<string, any> ) {
        this.url = `${environment.host}/home/actualizar-extracto`        
        try {
            await this.updateToken();
            const resp = await lastValueFrom(this.http.post<any>(this.url, { ...filtros }, { headers: this.header }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async rendicionesPorConcepto( filtros: Record<string, any> ) {
        this.url = `${environment.host}/home/rendiciones-concepto`
        try {
            await this.updateToken();
            const resp = await lastValueFrom(this.http.post<any>(this.url, { filtros }, { headers: this.header }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async ultimaRendicionCaja( filtros: Record<string, any> ) {
        this.url = `${environment.host}/home/ultima-rendicion-caja`
        try {
            await this.updateToken();
            const resp = await lastValueFrom(this.http.post<any>(this.url, { filtros }, { headers: this.header }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async rendicionCajadelDia ( filtros: Record<string, any>) {
        this.url = `${environment.host}/home/rendicion-caja-dia`
        try {
            await this.updateToken();
            const resp = await lastValueFrom(this.http.post<any>(this.url, { filtros }, { headers: this.header }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async getMontoPrestamo( filtros: Record<string,any> ) {
        this.url = `${environment.host}/home/monto-prestamo`
        try {
            await this.updateToken();
            const resp = await lastValueFrom(this.http.post<any>(this.url, { filtros }, { headers: this.header }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async montoClienteExtracto( filtros: Record<string,any> ) {
        this.url = `${environment.host}/home/monto-cliente-extracto`
        try {
            await this.updateToken();
            const resp = await lastValueFrom(this.http.post<any>(this.url, { filtros }, { headers: this.header }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async extractoAnual( filtros: Record<string,any> ) {
        this.url = `${environment.host}/home/extracto-anual`
        try {
            await this.updateToken();
            const resp = await lastValueFrom(this.http.post<any>(this.url, { filtros }, { headers: this.header }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async notificacionAnual( filtros: Record<string,any> ) {
        this.url = `${environment.host}/home/notificacion-anual`
        try {
            await this.updateToken();
            const resp = await lastValueFrom(this.http.post<any>(this.url, { filtros }, { headers: this.header }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async informeFacturacion( filtros: Record<string,any> ) {
        this.url = `${environment.host}/home/informe-facturacion`
        try {
            await this.updateToken();
            const resp = await lastValueFrom(this.http.post<any>(this.url, { filtros }, { headers: this.header }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

}
